/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Outcomeformsummarypartial3Inputs */

const en_outcomeformsummarypartial3 = /** @type {(inputs: Outcomeformsummarypartial3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contractor replied vaguely on ${i?.when}`)
};

const pt_outcomeformsummarypartial3 = /** @type {(inputs: Outcomeformsummarypartial3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empreiteiro respondeu de forma vaga em ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Contractor replied vaguely on {when}" |
*
* @param {Outcomeformsummarypartial3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformsummarypartial3 = /** @type {((inputs: Outcomeformsummarypartial3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformsummarypartial3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformsummarypartial3(inputs)
	return pt_outcomeformsummarypartial3(inputs)
});
export { outcomeformsummarypartial3 as "outcomeFormSummaryPartial" }